import React from "react";

class ErrorBlock extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.props;
    this.clickOkayButton = this.clickOkayButton.bind(this);
  }
  // Handler des Farbe
  clickOkayButton(event) {
    this.setState({ errorMessageText: "" });
    this.setState({ errName: [] });
    this.props.onErrorMessageText("");
  }
  render() {
    let zeigeErrorForm =
      "error-block modal " + (this.props.errorMessageText === "" ? "" : "open");
    let errorMessageText = this.props.errorMessageText;
    const errName = this.props.errName;
    const errors = [];
    return (
      <aside className={zeigeErrorForm}>
        <section className="modalcontainer">
          <img src="/images/i_dankeherz.svg" alt="" />
          <h4 className="center">{errorMessageText} </h4>
          <div>
            {Array.from(errName).forEach((data) => {
              errors.push(<p className="center">{data}</p>);
            })}
            {errors}
          </div>

          <a
            className="btn stdrose center"
            onClick={(e) => this.clickOkayButton(e)}
          >
            Okay
          </a>
        </section>
      </aside>
    );
  }
}
export default ErrorBlock;



// WEBPACK FOOTER //
// ./src/ErrorBlock.js